<template>
  <div>
    <b-form @keyup.enter="keySearch" onsubmit="return false">
      <el-row>
        <el-col :span="4">
          <el-button-group>
            <el-button @click="add" type="success" size="medium">
              {{ $l('btn_add_selection') || '添加选品' }}
            </el-button>
          </el-button-group>
        </el-col>
        <el-col :span="20">
          <el-input
            class="input-with-select"
            :placeholder="
              $l('table_label_search') ||
                '样品款号/样品名称(中/英文)/产品线搜索...'
            "
            size="medium"
            @keyup.enter="query"
            v-model="form.keyword"
            clearable
          >
            <el-button slot="append" icon="el-icon-search" @click="query">
              {{ $l('INDEX.product_dialog_btn_search') || '搜索' }}
            </el-button>
            <el-button slot="append" @click="advqueryDialogVisible = true">
              {{ $l('INDEX.product_dialog_btn_search_senior') || '高级搜索' }}
            </el-button>
          </el-input>
        </el-col>
      </el-row>
    </b-form>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      append-to-body
    >
      <el-form ref="form" size="small" :model="form" label-width="140px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.from_label_sample_style_no') || '样品款号'"
            >
              <el-input
                v-model.trim="form.sampleStyleNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_sampleSource') || '样品来源'"
            >
              <dict-select
                :placeholder="
                  $l('INDEX.sample_tips_select_sampleSource') ||
                    '请选择样品来源'
                "
                size="small"
                clearable
                filterable
                v-model="form.sampleSource"
                :body="{ dictType: 'sampleSource' }"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.order_form_label_productLine') || '产品线'"
              >
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('INDEX.sample_tips_select_productLine') ||
                        '请选择产品线'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.productLine"
                    :body="productLineParams"
                    url="/sys/common/dict/system"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('INDEX.pe_select_Level_1_sample_classification') ||
                        '请选择1级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.masterCategoryCode"
                    :body="queryMasterCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('INDEX.pe_select_Level_2_sample_classification') ||
                        '请选择2级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.categoryCode"
                    :body="queryCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.from_label_sample_name_cn') || '样品中文名称'"
            >
              <el-input
                v-model.trim="form.sampleName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_sample_composition') || '样品成分'"
            >
              <el-input
                v-model="form.sampleMetadata"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_factory') || '成品工厂'"
            >
              <dict-select
                :placeholder="
                  $l('INDEX.sample_tips_select_factory') || '请选择成品工厂'
                "
                size="small"
                clearable
                filterable
                multiple
                v-model="form.scmCodeList"
                url="/master/common/dict/scm"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.label_customer') || '客户'"
            >
              <dict-select
                clearable
                v-model="form.custCode"
                filterable
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.form_label_brand') || '品牌'"
            >
              <dict-select
                clearable
                v-model="form.brandCode"
                filterable
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_quotation_method') || '报价方式'"
              prop="quotedMethod"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.quotedMethod"
                :body="{ dictType: 'quotedMethod' }"
                :placeholder="
                  $l('INDEX.sample_tips_select_quotation_method') ||
                    '请选择报价方式'
                "
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.material_choose_moq_info') || '起订量'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.moqStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.moqEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      clearable
                      filterable
                      v-model="form.moqUnit"
                      :body="moqUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('INDEX.table_label_price') || '单价'">
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.costPriceStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.costPriceEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      :placeholder="
                        $l('form_label_pe_select_currency_unit') ||
                          '请选择货币单位'
                      "
                      size="small"
                      clearable
                      filterable
                      v-model="form.currencyUnit"
                      :body="currencyUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_quotedPrice') || '建议报价'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.quotedPriceStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.quotedPriceEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    size="small"
                    clearable
                    filterable
                    v-model="form.quotedCurrency"
                    :body="{ dictType: 'quotedCurrency' }"
                    :placeholder="
                      $l('INDEX.pe_select_quotedCurrency') ||
                        '请选择建议报价币种'
                    "
                    url="/sys/common/dict/system"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  productLineList: [],
  scmCodeList: [],
}
export default {
  components: {},
  data() {
    return {
      advqueryDialogVisible: false,
      dialogAddFormVisible: false,
      form: { ...initForm },
      productLineParams: { dictType: 'productLine' },
      queryMasterCategoryParams: { parentCode: 'x' },
      queryCategoryParams: { parentCode: 'x' },
      scmParams: {},
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
    }
  },
  watch: {
    // 查询条件下拉
    'form.productLine'() {
      this.form.masterCategoryCode = ''
      this.form.categoryCode = ''
      this.queryCategoryParams = { parentCode: '' }
      this.queryMasterCategoryParams = { parentCode: this.form.productLine }
    },
    'form.masterCategoryCode'() {
      this.form.categoryCode = ''
      this.queryCategoryParams = {
        parentCode: this.form.masterCategoryCode,
      }
    },
  },
  methods: {
    keySearch() {
      this.query()
    },
    add() {
      this.$emit('addMasterSample')
    },
    // 初始查询
    query() {
      this.dialogAddFormVisible = false
      this.$emit('submit', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {
        keyword: '',
        productLineList: [],
        scmCodeList: [],
      }
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
      this.dialogAddFormVisible = false
    },
  },
  created() {
    this.query()
  },
}
</script>
